import { computed, inject, Injectable } from '@angular/core';
import { AUTH_SERVICE, USER_SERVICE } from '@core-features/core';
import { EmbedBridgeService } from '../embed-bridge.service';
import { HelpContext } from './contact-options';
import { resolveHelpRegion } from './contact-regions';

/** Supplies the audience facts that decide which contact options are offered. */
@Injectable({ providedIn: 'root' })
export class HelpContextService {
  private readonly _authService = inject(AUTH_SERVICE);
  private readonly _userService = inject(USER_SERVICE);
  private readonly _embedBridge = inject(EmbedBridgeService);

  readonly $context = computed<HelpContext>(() => {
    const loggedIn = this._authService.$isAuthenticated();

    return {
      insidePaldesk: this._embedBridge.$isPaldeskHost(),
      loggedIn,
      isPartnerOrDealer:
        loggedIn &&
        !this._userService.isEndCustomer() &&
        !this._userService.isSupplier(),
      region: resolveHelpRegion(this._userService.$user()?.country),
    };
  });
}
